<template>
  <img
    :loading="!noLazy ? 'lazy' : 'eager'"
    :srcSet="getRatios().join(',')"
    :class="classes()"
    :alt="alt"
    :width="width"
    :height="height"
  />
</template>

<script>
export default {
  name: 'Picture',
  props: {
    img: String,
    width: Number,
    height: Number,
    ratios: {
      type: Array,
      default() {
        return [1, 2, 3];
      },
    },
    /**
     * Deprecated. Use extention as a string instead!
     */
    extentions: {
      type: Array,
      default() {
        return ['webp', 'jpg'];
      },
    },
    extention: {
      type: String,
      default: 'webp',
    },
    alt: {
      type: String,
      default: 'meine.pflege.de',
    },
    responsive: Boolean,
    noLazy: Boolean,
  },
  data() {
    return {
      el: 'o-picture',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--responsive`]: this.responsive,
        };
      },
    };
  },
  methods: {
    getRatios() {
      const files = [];
      this.ratios?.map((ratio) => {
        const filePath = `${this.img}${ratio > 1 ? `@${ratio}x` : ''}.${this.extention}`;
        files.push(`${filePath} ${ratio}x`);
      });
      return files;
    },
  },
};
</script>
